import Vue from 'vue'
import Router from 'vue-router'
import myReceiveResume from '../components/myReceiveResume.vue'
import myPost from '../components/myPost.vue'
import editPost from '../components/editPost.vue'
import newPost from '../components/newPost.vue'
import login from '../components/login.vue'
import loginRe from '../components/loginRe.vue'
import newPostGM from '../components/newPostGM.vue'
import my from '../components/my.vue'
import hrManagement from '../components/hrManagement.vue'
import myCompany from '../components/myCompany.vue'
import dhk from '../components/dhk.vue'
import companylist from '../components/companylist.vue'
import ai from '../components/ai.vue'
loginRe
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'myReceiveResume',
      component: myReceiveResume
    },
    {
      path: '/gpt',
      name: 'ai',
      component: ai
    },
    {
      path: '/myReceiveResume',
      name: 'myReceiveResume',
      component: myReceiveResume
    },
    {
      path: '/myPost',
      name: 'myPost',
      component: myPost
    },
    {
      path: '/dhk',
      name: 'dhk',
      component: dhk
    },
    {
      path: '/editPost',
      name: 'editPost',
      component: editPost
    },
    {
      path: '/newPost',
      name: 'newPost',
      component: newPost
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/loginRe',
      name: 'loginRe',
      component: loginRe
    },
    {
      path: '/newPostGM',
      name: 'newPostGM',
      component: newPostGM
    },
    {
      path: '/my',
      name: 'my',
      component: my
    },
    {
      path: '/hrManagement',
      name: 'hrManagement',
      component: hrManagement
    },
    {
      path: '/myCompany',
      name: 'myCompany',
      component: myCompany
    },
    {
      path: '/companylist',
      name: 'companylist',
      component: companylist
    }
  ]
})


export default router
